module.exports = __webpack_public_path__ + "img/Group_359.97c3ea20.png";